/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StaffOverviewEntryUserType } from './StaffOverviewEntryUserType';
import {
    StaffOverviewEntryUserTypeFromJSON,
    StaffOverviewEntryUserTypeFromJSONTyped,
    StaffOverviewEntryUserTypeToJSON,
} from './StaffOverviewEntryUserType';
import type { UserFacilityAccess } from './UserFacilityAccess';
import {
    UserFacilityAccessFromJSON,
    UserFacilityAccessFromJSONTyped,
    UserFacilityAccessToJSON,
} from './UserFacilityAccess';

/**
 * 
 * @export
 * @interface StaffOverviewEntry
 */
export interface StaffOverviewEntry {
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    user_type_id?: string;
    /**
     * 
     * @type {StaffOverviewEntryUserType}
     * @memberof StaffOverviewEntry
     */
    user_type?: StaffOverviewEntryUserType;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    s3_photo_key?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    facility_id?: string;
    /**
     * 
     * @type {string}
     * @memberof StaffOverviewEntry
     */
    last_sign_in_time?: string;
    /**
     * 
     * @type {Array<UserFacilityAccess>}
     * @memberof StaffOverviewEntry
     */
    matching_facility_access?: Array<UserFacilityAccess>;
    /**
     * 
     * @type {any}
     * @memberof StaffOverviewEntry
     */
    user_facility_accesses?: any | null;
}

/**
 * Check if a given object implements the StaffOverviewEntry interface.
 */
export function instanceOfStaffOverviewEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;

    return isInstance;
}

export function StaffOverviewEntryFromJSON(json: any): StaffOverviewEntry {
    return StaffOverviewEntryFromJSONTyped(json, false);
}

export function StaffOverviewEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffOverviewEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_type_id': !exists(json, 'user_type_id') ? undefined : json['user_type_id'],
        'user_type': !exists(json, 'user_type') ? undefined : StaffOverviewEntryUserTypeFromJSON(json['user_type']),
        'email': json['email'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        's3_photo_key': !exists(json, 's3_photo_key') ? undefined : json['s3_photo_key'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'last_sign_in_time': !exists(json, 'last_sign_in_time') ? undefined : json['last_sign_in_time'],
        'matching_facility_access': !exists(json, 'matching_facility_access') ? undefined : ((json['matching_facility_access'] as Array<any>).map(UserFacilityAccessFromJSON)),
        'user_facility_accesses': !exists(json, 'user_facility_accesses') ? undefined : json['user_facility_accesses'],
    };
}

export function StaffOverviewEntryToJSON(value?: StaffOverviewEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_type_id': value.user_type_id,
        'user_type': StaffOverviewEntryUserTypeToJSON(value.user_type),
        'email': value.email,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'title': value.title,
        'phone': value.phone,
        's3_photo_key': value.s3_photo_key,
        'facility_id': value.facility_id,
        'last_sign_in_time': value.last_sign_in_time,
        'matching_facility_access': value.matching_facility_access === undefined ? undefined : ((value.matching_facility_access as Array<any>).map(UserFacilityAccessToJSON)),
        'user_facility_accesses': value.user_facility_accesses,
    };
}

